/* src/app/private/components/packages/create-package/create-package.component.scss */
/*# sourceMappingURL=create-package.component.css.map */
